// SettingsDisplayPane.jsx

import React from 'react';

// Components
import Switch from 'components/switch/Switch';

/**
 * SettingsDisplayPane
 *
 * Renders display preferences for the current workspace.
 *
 * @param {object} theme - Active theme tokens for dynamic styling.
 * @param {boolean} isDarkMode - Whether dark mode is enabled.
 * @param {function} onThemeModeChange - Callback invoked when the theme mode toggle changes.
 *
 * @returns {ReactNode} The rendered display settings pane.
 */
const SettingsDisplayPane = React.memo(({
    theme,
    isDarkMode,
    onThemeModeChange,
    title = 'Display',
    subtitle = 'Workspace default appearance',
    settingLabel = 'Dark Mode',
    settingDescription = 'Applied as this workspace\'s default setting.',
    disabled = false,
}) => {

    // ----- RENDER ----- //

    return (
        <>
            <div className="settings-modal-pane-header">
                <div className="settings-modal-pane-header-left">
                    <div className="settings-modal-pane-title" style={{ color: theme.foreground }}>
                        {title}
                    </div>
                    <div className="settings-modal-pane-subtitle" style={{ color: theme.foregroundMuted }}>
                        {subtitle}
                    </div>
                </div>
            </div>

            <div className="settings-modal-pane-contents">
                <div className="settings-modal-theme-card">
                    <div className="settings-modal-theme-meta">
                        <div className="settings-modal-setting-label" style={{ color: theme.foreground }}>
                            {settingLabel}
                        </div>
                        <div className="settings-modal-setting-description" style={{ color: theme.foregroundMuted }}>
                            {settingDescription}
                        </div>
                    </div>

                    <Switch
                        checked={isDarkMode}
                        disabled={disabled}
                        onChange={onThemeModeChange}
                    />
                </div>
            </div>
        </>
    );
});

// Dev Tools
SettingsDisplayPane.displayName = 'SettingsDisplayPane';

export default SettingsDisplayPane;
